export enum QuestionType {
    SimpleQuestion = 'simple-question',
    ImageQuestion = 'image-question',
}

export const QuestionTypeGerman: Record<QuestionType, string> = {
    [QuestionType.SimpleQuestion]: 'Einfache Frage',
    [QuestionType.ImageQuestion]: 'Bildfrage',
};
